import { Button, Col, notification, Row, Spin, Table, Tag, Tooltip } from "antd";
import { UntrackedPositionShowSchema } from "../../../../../../models/Sweep";
import { useState } from "react";
import ImageDisplayer from "../../../../../utils/ImageDisplayer";
import SweepPictureService from "../../../../../../services/PictureService";
import SweepThumbnailService from "../../../../../../services/ThumbnailService";
import { useLanguage } from "../../../../../../context/LanguageContext";
import SweepService from "../../../../../../services/SweepService";
import { CheckCircleOutlined, StopOutlined } from "@ant-design/icons";

interface SummaryTableProps {
  sweepId: number
  positions: UntrackedPositionShowSchema[];
  showPictures: boolean;
  updateContent: () => void;
  loading: boolean;
  sweepStatus:string;
}

const SummaryTable = (props: SummaryTableProps) => {
  const { language } = useLanguage();
  const [pageSize, setPageSize] = useState<number>(10);
  let columns = [
    {
      title: language === "es" ? "Etiqueta de Posición" : "Position Label",
      key: "position_label",
      width: 120,
      render: (item: UntrackedPositionShowSchema) => {
        return (
          <Tag>{item.position_label}</Tag>
        );
      },
    },
    // {
    //   title: language === "es" ? "Imagen de Posición" : "Position Image",
    //   key: "image_position",
    //   width: 120,
    //   render: (item: UntrackedPositionShowSchema) => {
    //     return (
    //       <ImageDisplayer
    //         position_label={item.position_label}
    //         fetchFunction={() => {
    //           const paddedPositionLabel = item.position_label.padStart(5, " ");
    //           return SweepPictureService.getSweepPositionPicture(
    //             props.sweepId,
    //             paddedPositionLabel
    //           );
    //         }}
    //         lowfetchFuntion={(abortSignal: AbortSignal) => {
    //           const paddedPositionLabel = item.position_label.padStart(5, " ");
    //           return SweepThumbnailService.getSweepPositionThumbnail(
    //             props.sweepId,
    //             paddedPositionLabel,
    //             abortSignal
    //           );
    //         }}
    //         height={"50px"}
    //         width={"88.88px"}
    //       />
    //     );
    //   },
    // },
    {
      title: language === "es" ? "Etiqueta de Pallet" : "Pallet Label",
      key: "pallet_label",
      width: 120,
      render: (item: UntrackedPositionShowSchema) =>
        <Tag>{item.state === "empty" ? language === "es" ? "VACÍA" : "EMPTY" : item.pallet_label}</Tag>
      ,
    },
    // {
    //   title: language === "es" ? "Imagen de Pallet" : "Pallet Image",
    //   key: "image_pallet",
    //   width: 120,
    //   render: (item: UntrackedPositionShowSchema) => {
    //     return (
    //       <ImageDisplayer
    //         position_label={item.position_label}
    //         fetchFunction={() => {
    //           const paddedPositionLabel = item.position_label.padStart(5, " ");
    //           return SweepPictureService.getSweepPalletPicture(
    //             props.sweepId,
    //             paddedPositionLabel
    //           );
    //         }}
    //         lowfetchFuntion={(abortSignal: AbortSignal) => {
    //           const paddedPositionLabel = item.position_label.padStart(5, " ");
    //           return SweepThumbnailService.getSweepPalletThumbnail(
    //             props.sweepId,
    //             paddedPositionLabel,
    //             abortSignal
    //           );
    //         }}
    //         height={"50px"}
    //         width={"88.88px"}
    //       />
    //     );
    //   },
    // },
    {
      title: language === "es" ? "Estado" : "State",
      key: "state",

      width: 120,
      render: (item: UntrackedPositionShowSchema) => {
        if (language === "es") {
          switch (item.state) {
            case "full":
              return "Ocupada"
            case "empty":
              return "Vacía"
            case "unknown":
              return "Desconocida"
            default:
              return "Inválida"
          }
        } else { return item.state.charAt(0).toUpperCase() + item.state.slice(1);}
      },
    },
    {
      title: language === "es" ? "Seguimiento " : "Tracked state",
      key: "tranking_state",

      width: 120,
      render: (item: UntrackedPositionShowSchema) => {
        if (language === "es") {
          switch (item.tracking_status) {
            case "untracked":
              return "Sin seguimiento";
            case "accepted":
              return "Aceptada";
            case "rejected":
              return "Rechazada";
            default:
              return "Sin seguimiento";
          }
        } else {
          return item.tracking_status.charAt(0).toUpperCase() + item.tracking_status.slice(1);
        }
      },
    },
    {
      title: language === "es" ? "Acciones" : "Actions",
      key: "actions",
      width: 100,
      render: (item: UntrackedPositionShowSchema) => {
        return <Row gutter={[10, 10]} >
          <Col xs={12} sm={12} md={12} lg={12} >
            <Tooltip title={language === "es" ? "Agregar" : "Add"}>
              <Button
                disabled={item.tracking_status === "accepted"|| item.uploaded|| props.sweepStatus !== "processing"}
                style={{ backgroundColor: (props.sweepStatus == "processing"&&item.tracking_status !== "accepted"&& item.uploaded===false ? "#73d13d" : "") }}
                type="primary"
                shape="round"
                icon={<CheckCircleOutlined />}
                onClick={() => {
                  SweepService.setUntrakedPositon(props.sweepId.toString(), "add", item.idx).then((res) => {
                    if (res === "OK") {
                      notification.success({
                        message: language === "es" ? "Éxito" : "Success",
                        description: language === "es"
                          ? "Posición agregada correctamente."
                          : "Position add successfully.",
                      });
                      props.updateContent();
                    } else {
                      notification.error({
                        message: language === "es" ? "Error" : "Error",
                        description: language === "es"
                          ? "No se pudo agregar la posición."
                          : "Failed to add position.",
                      });
                    }
                  });
                }}
              />
            </Tooltip>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12} >
            <Tooltip title={language === "es" ? "Descartar" : "Discard"}>
              <Button
                disabled={item.tracking_status === "rejected" || item.uploaded||props.sweepStatus !== "processing"}
                style={{ backgroundColor: (props.sweepStatus == "processing"&&item.tracking_status !== "rejected"&& item.uploaded===false? "#ff4d4f" : "") }}
                type="primary"
                shape="round"
                icon={<StopOutlined />}
                onClick={() => {
                  SweepService.setUntrakedPositon(props.sweepId.toString(), "discard", item.idx).then((res) => {
                    if (res === "OK") {
                      notification.success({
                        message: language === "es" ? "Éxito" : "Success",
                        description: language === "es"
                          ? "Posición descartada correctamente."
                          : "Position discarded successfully.",
                      });
                      props.updateContent();
                    } else {
                      notification.error({
                        message: language === "es" ? "Error" : "Error",
                        description: language === "es"
                          ? "No se pudo descartar la posición."
                          : "Failed to discard position.",
                      });
                    }
                  });
                }}
              />
            </Tooltip>
          </Col>
        </Row>;
      }
    },
    {
      title: language === "es" ? "Estado en JD" : "JD status",
      key: "state",
      
      width: 50,
      render: (item: UntrackedPositionShowSchema) => {
          if (item.uploaded) {
            return <Tag  color="green">{language === "es" ? "Subido" : "Uploaded"}</Tag>
          }
          else {
            return <Tag color="red">{language === "es" ? "No subido" : "Not uploaded"}</Tag>
          }
      },
    },
  ];

  if (!props.showPictures) {
    columns = columns.filter(
      (column) => column.key !== "image_position"
    );
  }

  const paginationConfig = {
    pageSize: pageSize,
    total: props.positions.length,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50"],
    onChange: (page: number, pageSize: number | undefined) => {
      if (pageSize) {
        setPageSize(pageSize);
      }
    },
  };


  return (
    <Spin spinning={props.loading}>
      <Table
        columns={columns}
        dataSource={props.positions}
        rowKey="id"
        scroll={{ x: (1000) }}
        size="small"
        pagination={paginationConfig}
        showSorterTooltip={true}
        
      />
    </Spin>
  );
};

export default SummaryTable;
